module.exports = __webpack_public_path__ + "static/media/logo-norwegian.eac5ed64.png";